module.exports = __webpack_public_path__ + "img/qrcode.985e24b5.png";